/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { service } from '@ember/service';
import FormValidationService from 'walden-fast/services/form-validation';

interface FormFieldWithValidationArgs {
  fieldName: string;
}

interface FormFieldWithValidationSignature {
  Args: FormFieldWithValidationArgs;
  Blocks: {
    default: [
      {
        errors: string[];
        hasErrors: boolean;
        isInvalid: boolean;
      },
    ];
  };
}

export default class FormFieldWithValidationComponent extends Component<FormFieldWithValidationSignature> {
  @service('form-validation')
  declare formValidationService: FormValidationService;

  get localizedValidationErrors() {
    return this.formValidationService.getLocalizedValidationErrors();
  }

  get hasFieldErrors(): boolean {
    return this.formValidationService.hasFieldErrors(this.args.fieldName);
  }
}
